import { render, staticRenderFns } from "./SupplierPersonSelect.vue?vue&type=template&id=2dc5d42f"
import script from "./SupplierPersonSelect.vue?vue&type=script&lang=js"
export * from "./SupplierPersonSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports